import React, { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Edit } from '@material-ui/icons'
import { Link, useNavigate } from 'react-router-dom'
import Axios from 'axios'
import { showGPA } from '../components/functions/education'
import Persattrscore from '../components/Persattrscore'
import ModelComment from './ModelComment'
import { toast} from 'react-toastify'

// import { showGPA, listStudyResults } from "../components/functions/education";

function getFullName(params) {
  return `${params.row.Rank || ''} ${params.row.PersFname || ''} ${
    params.row.PersLname || ''
  }`
}



//คิดเกรดเฉลี่ยสะสม/GPA
const sumWeightPoint = (params) => {
  const gradeAll = []
  const credit = []
  let sum = 0
  let total = 0
  for (let i = 1; i < 8; i++) {
    gradeAll.push(params.row[`grade_${i}`])
  }
  for (let i = 1; i < 8; i++) {
    credit.push(params.row[`credit_${i}`])
  }
  const grade = gradeAll.filter((item) => item !== null)
  const creditScore = credit.filter((item) => item !== null)
  for (let i = 0; i < grade.length; i++) {
    sum = showGPA(grade[i]) * creditScore[i]
    total += sum
  }
  return total
}

const sumWeightPointAndValus = (params) => {
  const credit = []
  let total = 0
  for (let i = 1; i < 8; i++) {
    credit.push(params.row[`credit_${i}`])
  }
  
  const creditScore = credit.filter((item) => item !== null)
  
  for (let i = 0; i < creditScore.length; i++) {
    total += credit[i]
  }
  return total
}

export default function TableSummarize({
  classNo,
  seminarNo,
  isSubmit,
  // courseNum,
  btnUpload,
}) {
  const setClass = classNo
  const setSeminar = seminarNo
  // console.log("data:", setSeminar)

  const [selected, setSelected] = useState([])
  const AccessRights = localStorage.getItem('AccessRights')
  const token = JSON.parse(localStorage.getItem('token'))
  const auth = localStorage.getItem('Access')
  const CourseId = AccessRights.substring(11, 14)
  const navigate = useNavigate()

  const columns = [
    {
      field: 'id',
      headerName: 'ลำดับ',
      width: 65,
      align: 'center',
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
    },
    { field: 'StudentId', headerName: 'เลขประจำตัว นทน.', width: 140,align: 'center' },
    {
      field: 'fullName',
      headerName: 'ยศ ชื่อ สกุล',
      width: 180,
      valueGetter: getFullName,
    },
    {
      field: 'RemainScore',
      headerName: 'เกรดเฉลี่ยสะสม/GPA',
      width: 150,
      align: 'center',
      renderCell: (params) => {
        const averageScore = sumWeightPoint(params) / sumWeightPointAndValus(params)
        const GPA = averageScore === 0 ? "ไม่มีคะแนน" : averageScore.toFixed(2)
        return (
          <>
            {GPA === 'ไม่มีคะแนน' ? (
              <>
                <h5>-</h5>
              </>
            ) : (
              <>{GPA}</>
            )}
          </>
        )
      },
      // valueGetter: getGPA,
    },
    {
      field: 'averagescore',
      headerName: 'คะแนนเฉลี่ยคุณลักษณะส่วนบุคคล',
      width: 230,
      align: 'center',
      renderCell: (params) => {
        // console.log(params);
        const courseGrp = params.row.CourseGrp
        const courseid = params.row.cutstring
        const persid = params.row.PerId
        const checkPage = 1
  
        return (
          <>
            <Persattrscore
              courseGrp={courseGrp}
              courseid={courseid}
              persid={persid}
              checkPage={checkPage}
            />
          </>
        )
      },
    },
    {
      field: 'comment',
      headerName: 'ความคิดเห็นผู้บังคับบัญชา',
      width: 180,
      align: "center",
      renderCell: (params) => {
        const rank = params.row.Rank
        const name = params.row.PersFname
        const lname = params.row.PersLname
        const id = params.row.PerId
        const fullName = `${rank} ${name} ${lname}`
        const stdId = params.row.StudentId
  
        return (
          <>
            <ModelComment persid={id} name={fullName} stdId={stdId} />
          </>
        )
      },
    },
    auth === "ปกครอง" || auth === "วัดผลส่วนกลาง"
    ? {
      // check auth
      field: "note",
      headerName: "หมายเหตุ",
      width: 110,
      renderCell: (params) => {
        const averageScore = sumWeightPoint(params) / sumWeightPointAndValus(params)
        const GPA = averageScore === 0 ? "ไม่มีคะแนน" : averageScore.toFixed(2)
        return (
          <>
            {GPA === 'ไม่มีคะแนน' ? (
              <>
                <h5>-</h5>
              </>
            ) : (
              <>{GPA}</>
            )}
          </>
        )
      },
    }
    : {
      field: 'details',
      headerName: 'รายละเอียดเพิ่มเติม',
      width: 140,
      align: "center",
      renderCell: (params) => {
        return (
          <>
            <Link
              to={`/PageEditSummarize/${params.row.PerId}`}
              state={{
                coursegrp: params.row.CourseGrp,
                seminar: params.row.Seminar,
                AccessRightsId : params.row.AccessRightsId,
              }}
            >
              <Edit className="userListDate" />
            </Link>
          </>
        )
      },
    },
    auth !== "ปกครอง" || auth !== "วัดผลส่วนกลาง"
    ? 
    {
      field: "note",
      headerName: "หมายเหตุ",
      width: 110,
      renderCell: (params) => {
        const averageScore = sumWeightPoint(params) / sumWeightPointAndValus(params)
        const GPA = averageScore === 0 ? "ไม่มีคะแนน" : averageScore.toFixed(2)
        return (
          <>
            {GPA === 'ไม่มีคะแนน' ? (
              <div className="text-danger">
              <h6>
                <small>ไม่มีคะแนน</small>
              </h6>
            </div>
            ) : (
              <div className="text-success">
                  <h6>
                    <small>มีคะแนนแล้ว</small>
                  </h6>
                </div>
            )}
          </>
        )
      },
    }
    :{hide: true,}
  ]

  const getData = async () =>{
    await Axios.get(
      process.env.REACT_APP_API + `/result/course/${setClass}/seminar/${setSeminar}/${CourseId}?token=${token}`,
    )
      .then((res) => {
        setSelected(res.data.data1);
        // setbuttnUpload(false)
        // console.log("data: ",res.data)
      })
      .catch((err) => {
        if(err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate('/')
        } else {
          console.log("err: ", err.response.data)
        }
      })
  }
  useEffect(() => {
    if (isSubmit) {
      getData()
    }
    setSelected([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmit, btnUpload])

  const sortStudent = selected.slice().sort((a, b) => a.Seminar - b.Seminar); 
  return (
    <React.Fragment>
      <div style={{ height: 700, width: '100%' }}>
        <DataGrid
          getRowId={(row) => row.PerId}
          rows={sortStudent}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </div>
    </React.Fragment>
  )
}
